import { BaseComponent } from './base.component';

export abstract class BaseLayoutComponent extends BaseComponent {

}
